exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fn-btn__group>.fn-btn{border-radius:0;border-right-width:0;margin-right:0}.fn-btn__group>.fn-btn:first-child{border-top-left-radius:2px;border-bottom-left-radius:2px}.fn-btn__group>.fn-btn:last-child{border-top-right-radius:2px;border-bottom-right-radius:2px;border-right-width:1px}", ""]);

// exports
exports.locals = {
	"prefixCls": "fn-btn__group",
	"fn-btn__group": "fn-btn__group",
	"fn-btn": "fn-btn"
};